// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"loadingSpinner--1D-OT","rotation":"rotation--2TV2v"};